module.exports = __webpack_public_path__ + "img/cimg02.d40285ce.png";